import { render, staticRenderFns } from "./CustomerInactivityForm.vue?vue&type=template&id=44631b68&scoped=true&"
import script from "./CustomerInactivityForm.vue?vue&type=script&lang=ts&"
export * from "./CustomerInactivityForm.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerInactivityForm.vue?vue&type=style&index=0&id=44631b68&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44631b68",
  null
  
)

export default component.exports